import { ReactComponent as NoNameLogo } from '../../assets/images/brand-logo.svg';
import { ReactComponent as NamedLogo} from "../../assets/images/logo-name.svg";

interface BrandLogoProps {
  expand?: boolean;
}

const BrandLogo = ({
  expand = false,
}: BrandLogoProps) => {
  return (
    <div className="h-6 w-28">
      {expand ? <NamedLogo fill="#191818" /> : <NoNameLogo fill="#191818" /> }
    </div>
  );
};

export default BrandLogo;
